<template>
  <div
    id="summary"
    class="app-container content-container"
  >
    <div>
      <h1>Fakes? No, thanks!</h1>

      <p>
        <b>
          We hope you are now ready to spot fake news.
          Make sure you remember about these key rules while reading online content!
        </b>
      </p>

      <ol>
        <li>
          Inspect closely any suspicious and unknown sources of information.
        </li>
        <li>
          Remember that photographs or memes embedded in an article can also be fake or manipulated.
        </li>
        <li>
          Pay special attention to extremely emotional content,
          numerous exclamation and quotation marks and capital letters.
        </li>
      </ol>
    </div>
    <div class="buttons">
      <router-link
        tag="button"
        type="button"
        name="button"
        class="opaque-blue"
        to="/share-results"
      >
        Next
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Summary',
};
</script>

<style scoped>
#summary {
  color: var(--color-blue);
  background: #EBF1F4;
  position: relative;
}
.buttons {
  display: flex;
  width: 100%;
  z-index: 10;
}
.buttons a {
  margin-top: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/Summary.vue